import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpsertLocation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ _id, groupAncestors: _, ...json }) => {
      if (_id) {
        return api
          .patch(`locations/${_id}`, {
            headers: { 'content-type': 'application/merge-patch+json' },
            json,
          })
          .json();
      } else {
        return api.post('locations', { json }).json();
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['locations'] }),
  });
}
